/* import __COLOCATED_TEMPLATE__ from './order.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import type { ShippingAddress, Order } from './types';

export default class Inbox2Order extends Component<{
  Args: {
    order: Order;
    onShippingAddressUpdate: (orderId: number, newShippingAddress: ShippingAddress) => void;
    onRefundSuccess?: () => void;
    onReplacementSuccess?: () => void;
    onGiftCardSuccess?: () => void;
    expandedOrderIds: Set<number>;
    toggleOrderExpanded: (orderId: number) => void;
    shopifyCustomerId?: number;
    onNavigateToOrder?: (fromOrderId: number, toOrderId: number) => void;
    conversationId: number;
    userId: string;
  };
}> {
  get isExpanded() {
    return (
      (this.args.order.id !== null && this.args.expandedOrderIds?.has(this.args.order.id)) || false
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::Order': typeof Inbox2Order;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/order': typeof Inbox2Order;
  }
}
